import Cookies from 'js-cookie';

$(function() {
	if((typeof Cookies.get('carCookiesModal') == 'undefined' || Cookies.get('carCookiesModal') == 'false') && environment != 0) {
        $('#cookiesModal').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
        });
    }

	var trigger = 'hover';
	if($(document).width()<1000) {
		trigger = 'manual';
	}
	$("[data-toggle=popover]").each(function(i, obj) {
		$(this).popover({
			html: true,
			sanitize: false,
			trigger: trigger
		}).on('click', function(e) {
			$(this).popover('toggle');
		});
	});
	$('body').on('click', function (e) {
        //did not click a popover toggle, or icon in popover toggle, or popover
        if ($(e.target).data('toggle') !== 'popover'
            && $(e.target).parents('[data-toggle="popover"]').length === 0
            && $(e.target).parents('.popover.in').length === 0) { 
            $('[data-toggle="popover"]').popover('hide');
        }
    });
    $('#cookies-more-info, #cookies-back').on('click', function(){
        $('.cookies-first-step, .cookies-second-step').toggleClass('hidden');
    });

    $('.cookies-accept').on('click', function(){
        $('#cookiesModal').modal('hide');
        Cookies.set('carCookiesModal', true, { expires: 365, path: '/', secure: true, sameSite: 'strict' });

        if ($(this).hasClass("cookies-selected")) {
            if (!$("#statistics").is(":checked")) {
                window['ga-disable-'+gaCode] = true;
                Cookies.remove('_gid', { path: '/' });
                Cookies.remove('_ga', { path: '/' });
                Cookies.remove('_gat', { path: '/' });
                return;
            }
        }

        Cookies.set('ga_allow', true, { expires: 365, path: '/', secure: true, sameSite: 'strict' });
        activateGA();
	});

	$('.cookies-refuse').on('click', function(){
		$('#cookiesModal').modal('hide');
	});

    function activateGA() {
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());

		gtag('config', gaCode);
    }

	//offical brand
	 if($('#offical-brand').length>0) {
        $('#appointment_vehicle_brand').val($('#offical-brand').val()).trigger("change");
	}
	
	$('#appointment_vehicle_brand').select2({
		width: '100%',
		placeholder: ' '
	});
	$('#appointment_vehicle_model').select2({
		width: '100%'
	});

	$(".langSel").select2({ width: '120px', minimumResultsForSearch: Infinity, dropdownPosition: 'above' });
	$(".langSel").change(function() {
		top.location = langUrl[$(this).val()];
	});
	
	$('.search-workshop').on('click', function() {
		var val = $('#appointment_workshop_city').val();
		if(val.length>3) {
			$.ajax({
				url: $('#url-base-lang').val()+"procesor/workflows",
				data:'filter='+val,
				type:'POST',
				success:function(result){	
					if(result!='-1') {
						var data = jQuery.parseJSON(result);
						setTimeout(paintWorkflows(data), 1000);
					}
					return false;
				}
			});
		}
	})
	
	//terms and conditions
	$('.conditionsBox a').on('click', function(event) {
		event.preventDefault();
		$(".terms").toggle("slow");
	});
});

export function getDatepickerArrow(lang) {
	if(lang=='he') {
		return {
			'previous': 'fas fa-chevron-right',
			'next': 'fas fa-chevron-left',
		};
	}
	else {
		return {
			'previous': 'fas fa-chevron-left',
			'next': 'fas fa-chevron-right',
		};
	}
}

export function getLocaleJS(lang) {
	switch(lang){
		case 'es':
			return 'es-ES'
		break;
		case 'ca':
			return 'ca-ES'
		break;
		case 'fr':
			return 'fr-FR'
		break;
		case 'us':
			return 'en-US'
		break;
		case 'gb':
			return 'en-GB'
		break;
		case 'de':
			return 'de-DE'
		break;
		case 'he':
			return 'he-IL'
		break;
		case 'pt':
			return 'pt-PT';
		break;
		case 'mx':
			return 'es-MX';
		break;
		default:
			return 'en-GB';
	}		
}

if($('.form-main-first').length>0) {
	$('#appointment_vehicle_plate').val('');
	$('#appointment_vehicle_kms').val('');
	$('#appointment_vehicle_kms').val('');
	$('#branches-searcher').val('');
	$('#advisor_id').val('');
	$('#advisor_name').val('');
	$('#advisor_slot').val('');

	$('#ws-id').val('');
	$('#schedule_date').val('');
	$('#schedule_hour').val('');

	$('#appointment_name').val('');
	$('#appointment_surname').val('');
	$('#appointment_surname_second').val('');
	$('#appointment_dni').val('');
	$('#appointment_tlf').val('');
	$('#appointment_mail').val('');
};

$(window).on('load', function() {
	if($('#wf-address').length>0) {
		var name = $('#wf-name').val();
		var address = $('#wf-address').val();
		var city = $('#wf-city').val();
		var state = $('#wf-state').val();
		var postalCode = $('#wf-postal_code').val();
		var tlf = $('#wf-telephone').val();
		var name = $('#wf-name').val();
		if(state!='') {
			var place = name + ", " + address + ", " + postalCode + ", " + city + ", " + state;
		} else {
			var place = name + ", " + address + ", " + postalCode + ", " + city;
		}
		var contentString = '<div id="content">'+
		'<div id="siteNotice">'+
		'</div>'+
		'<h4 id="firstHeading" class="firstHeading">'+name+'</h4>'+
		'<div id="bodyContent">'+
		'<p>'+ place +'</p>'+
		'<p>'+tlf+'</p>'+
		'</div></div>';
		var geocoder;
		var map;
		if($('#wf-address').length>0) {
			geocoder = new google.maps.Geocoder();
			var latlng = new google.maps.LatLng(0, 0);
			var mapOptions = {
				center: latlng,
				zoom: 17,
			}
			map = new google.maps.Map(document.getElementById('wf-map-created'), mapOptions);
		}
		
		$('.appointment-created-info #wf-map-created').hide();

		geocoder.geocode( { 'address': place}, function(results, status) {
			if (status == 'OK') {
				$('.appointment-created-info #wf-map-created').show();
				icon: $('#url-img').val()+'map-marker.png',
				map.setCenter(results[0].geometry.location);
				var marker = new google.maps.Marker({
						map: map,
						position: results[0].geometry.location,
						title: name.toUpperCase(),
						animation: google.maps.Animation.DROP,
				});
				
				map.addListener('center_changed', function() {
					window.setTimeout(function() {
						map.panTo(marker.getPosition());
					}, 3000);
				});
		
				marker.addListener('click', function() {
					map.setZoom(20);
					map.setCenter(marker.getPosition());
					infowindow.open(map, marker);
				});

				var infowindow = new google.maps.InfoWindow({
					content: contentString
				});
			} else {
				// hide branch map
				$('.appointment-created-info #wf-map-created').hide();
			}
		});
	}
})